import * as React from 'react';

import {EntitySelectRow} from 'shells/entity/entity-select-row';

// @ts-expect-error
import getClassesMixin from '../../mixins/get-classes';

type Props = {
    searchResult: any;
    isSelected?: boolean;
    onClick: (e: Event, searchResult: any) => any;
};

export class SearchResultItem extends React.Component<Props> {
    getClasses = getClassesMixin;

    static defaultProps = {
        onClick: () => {},
    };

    render() {
        const {searchResult, isSelected, onClick} = this.props;
        const entity = searchResult.getEntity();
        const escapedInfo = searchResult.getEscapedInfo();
        const entityType = entity.get('type');
        const classes = this.getClasses('ui-popover__search-result', {
            selected: isSelected,
        });

        // Necessary to prevent textfield's blur event to cause a state
        // change in the autocompleteResults and hide the list before the
        // click event can properly fire.
        // @ts-expect-error
        const stop = function (e) {
            e.preventDefault();
            e.stopPropagation();
        };

        return (
            <li
                className={classes}
                // @ts-expect-error
                onClick={(e) => onClick(e, searchResult)}
                onMouseDown={(e) => stop(e)}
            >
                <EntitySelectRow
                    entity={{
                        id: entity.get('id'),
                        description: escapedInfo.description,
                        type: entityType,
                        value: escapedInfo.primaryName ? (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: escapedInfo.primaryName,
                                }}
                            />
                        ) : undefined,
                        avatarUrl: searchResult.get('avatarUrl'),
                        initials: searchResult.get('initials'),
                        // @ts-expect-error
                        relatedType: searchResult.get('relatedType'),
                        secondaryInfo: escapedInfo.relatedName ? (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: escapedInfo.relatedName,
                                }}
                            />
                        ) : undefined,
                        tertiaryInfo: escapedInfo.relatedInfo ? (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: escapedInfo.relatedInfo,
                                }}
                            />
                        ) : undefined,
                    }}
                />
            </li>
        );
    }
}
